<div class="empty-state">
  <img
    class="empty-state-image"
    [cdsSource]="image"
    [alt]="alt || message"
  >
  <p class="empty-state-message">{{ message }}</p>
</div>
